import Parse from "parse";

import type { Article } from "./Article";

type OD3_Source = Parse.Object;

export interface OrderPlanAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  article?: Article;
  ordernr: string;
  planEnd?: Date;
  planStart?: Date;
  setup_time: number;
  source?: OD3_Source;
  target_quantity: number;
}

export class OrderPlan extends Parse.Object<OrderPlanAttributes> {
  static className: string = "OD3_MES_OrderPlan";

  constructor(data?: Partial<OrderPlanAttributes>) {
    super("OD3_MES_OrderPlan", data as OrderPlanAttributes);
  }

  get article(): Article | undefined {
    return super.get("article");
  }
  set article(value: Article | undefined) {
    super.set("article", value);
  }
  get ordernr(): string {
    return super.get("ordernr");
  }
  set ordernr(value: string) {
    super.set("ordernr", value);
  }
  get planEnd(): Date | undefined {
    return super.get("planEnd");
  }
  set planEnd(value: Date | undefined) {
    super.set("planEnd", value);
  }
  get planStart(): Date | undefined {
    return super.get("planStart");
  }
  set planStart(value: Date | undefined) {
    super.set("planStart", value);
  }
  get setup_time(): number {
    return super.get("setup_time");
  }
  set setup_time(value: number) {
    super.set("setup_time", value);
  }
  get source(): OD3_Source | undefined {
    return super.get("source");
  }
  set source(value: OD3_Source | undefined) {
    super.set("source", value);
  }
  get target_quantity(): number {
    return super.get("target_quantity");
  }
  set target_quantity(value: number) {
    super.set("target_quantity", value);
  }
}

Parse.Object.registerSubclass("OD3_MES_OrderPlan", OrderPlan);
